var throttle=function throttle(callback,timeFrame){var lastTime=0;return function(){var now=new Date();// @ts-ignore
if(now-lastTime>=timeFrame){callback();lastTime=now;}};};export default throttle;